// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__Vv9Cw","questions":"styles_questions__1f2Tp","footer":"styles_footer__2hJbo"};